<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_reportDate') || '巡检日期'"
            prop="reportDate"
          >
            <el-date-picker
              v-model="formData.reportDate"
              :placeholder="
                $l('form_placeholder_reportDate') || '请选择巡检日期'
              "
              type="date"
              value-format="yyyy-MM-dd"
              :picker-options="reportDatePickerOptions"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item
            :label="$l('form_label_reportPersons') || '巡检人员'"
            prop="listUser"
          >
            <ReportPersonInput
              v-model="formData.listUser"
              :placeholder="
                $l('form_placeholder_reportPersons') || '请选择巡检人员'
              "
              :disabled="disabled"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_workShop') || '巡检车间'"
            prop="workShopCode"
          >
            <dict-select
              v-model="formData.workShopCode"
              url="/factory/workshop/select"
              :placeholder="$l('form_placeholder_workShop') || '请选择巡检车间'"
              size="mini"
              filterable
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_pdProcessDictStep') || '巡检工序'"
            prop="pdProcessDictStep"
          >
            <dict-select
              v-model="formData.pdProcessDictStep"
              :placeholder="
                $l('form_placeholder_pdProcessDictStep') || '请选择巡检工序'
              "
              methods="GET"
              :url="
                `/factory/mrp/pending/goods/inspection/selectProcessDictionary/${_pendingGoodsCode}`
              "
              :selectedLabel.sync="formData.processName"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_checkedQty') || '巡检数量'"
            prop="checkedQty"
          >
            <el-input-number
              v-model="formData.checkedQty"
              :placeholder="
                $l('form_placeholder_checkedQty') || '请输入巡检数量'
              "
              :min="0"
              :step="1"
              :precision="0"
              :controls="false"
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_notPassQty') || '不良数量'">
            <el-input v-model="notPassQty" clearable readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_passQty') || '良品数量'">
            <el-input v-model="passQty" clearable readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <InspectionIssuesItems
      :data.sync="formData.listIssues"
      :disabled="disabled"
    />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import dayjs from 'dayjs'
import lodash from 'lodash'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { add, subtract } from '@/libs/util.number.js'
import ReportPersonInput from '../report-person-input'
import InspectionIssuesItems from '../inspection-issues-items'
export default {
  mixins: [EditLoading],
  components: { ReportPersonInput, InspectionIssuesItems },
  props: {
    disabled: { type: Boolean, default: false },
    pendingGoodsInspectionCode: { type: String, default: '' },
    pendingGoodsCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: { reportDate: '', listUser: [], listIssues: [] },
      rules: {
        reportDate: [
          {
            required: true,
            message: this.$l('form_placeholder_reportDate') || '请选择巡检日期',
            trigger: 'change',
          },
        ],
        listUser: [
          {
            required: true,
            message:
              this.$l('form_placeholder_reportPersons') || '请选择巡检人员',
            trigger: 'change',
          },
        ],
        workShopCode: [
          {
            required: true,
            message: this.$l('form_placeholder_workShop') || '请选择巡检车间',
            trigger: 'change',
          },
        ],
        pdProcessDictStep: [
          {
            required: true,
            message:
              this.$l('form_placeholder_pdProcessDictStep') || '请选择巡检工序',
            trigger: 'change',
          },
        ],
        checkedQty: [
          {
            required: true,
            message: this.$l('form_placeholder_checkedQty') || '请输入巡检数量',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  new Error(
                    this.$l('form_placeholder_checkedQty_cannot_be_zero') ||
                      '巡检数量不能为零',
                  ),
                )
                return
              }

              if (value < this.notPassQty) {
                callback(
                  new Error(
                    this.$l(
                      'form_placeholder_checkedQty_cannot_be_less_than_no',
                    ) || '巡检数量不能小于不良数量',
                  ),
                )
                return
              }

              callback()
            },
          },
        ],
      },
      reportDatePickerOptions: {
        disabledDate(time) {
          return new Date().getTime() < time.getTime()
        },
      },
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
    _pendingGoodsCode() {
      return this.pendingGoodsCode || this.formData.pendingGoodsCode || 'xx'
    },
    notPassQty() {
      return lodash.reduce(
        lodash.map(this.formData.listIssues, 'quantity'),
        add,
        0,
      )
    },
    passQty() {
      return subtract(this.formData.checkedQty, this.notPassQty)
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    init() {
      if (this.pendingGoodsInspectionCode) return this.getData()

      const { userCode, userNo, userName } = this.userInfo || {}
      this.formData.reportDate = dayjs().format('YYYY-MM-DD')
      this.formData.listUser = [{ userCode, userNo, userName }]
    },
    async getData() {
      const res = await this.$api
        .mrpPendingGoodsInspectionDetailApi({
          pendingGoodsInspectionCode: this.pendingGoodsInspectionCode,
        })
        .catch(() => null)
      if (!res) return

      const data = res.body || {}

      this.formData = data
      this.$emit('loaded', data)
    },
    async preSave() {
      if (!this.pendingGoodsInspectionCode) return Promise.reject()

      const result = await validate.formValidate([this.$refs.form])
      if (!result) return Promise.reject()

      const res = await this.$api
        .mrpPendingGoodsInspectionSaveApi(this.formData)
        .catch(() => null)

      if (!res) return Promise.reject()

      if (200 == res.status) await this.init()

      return Promise.resolve(res)
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .mrpPendingGoodsInspectionSaveApi({
          pendingGoodsCode: this.pendingGoodsCode,
          ...this.formData,
        })
        .catch(() => null)
      this.loadingClose()

      if (!res) return

      const { status, msg, body } = res
      if (status !== 200) {
        this.$message.error(msg)
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('tips_save_ok') || '保存成功',
        type: 'success',
      })

      if (this.pendingGoodsInspectionCode) {
        this.getData()
        return
      }

      this.$emit('add-success', body)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-input-number {
  .el-input__inner {
    text-align: left;
  }
}
</style>
